/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect } from 'react';
// material
import Space from 'material/space/space';
import {  } from '@insticator/insticator-ui/dist/material';
import { ReactComponent as CommentIcon } from 'assets/icons/product-layout/comment.svg'
import { ReactComponent as TrendingNowIcon } from 'assets/icons/product-layout/trending-now.svg'
import { ReactComponent as ArticleSentimentIcon } from 'assets/icons/product-layout/article-sentiment.svg'
// styles
import injectSheet from 'react-jss'
import styles from './producttabs_styles'

/* ========== ~~~~~~~~~~ PRODUCT MANAGER: PAGE SETUP : PREVIEW PRODUCT TABS ~~~~~~~~~~ ========== */
const ProductTabs = injectSheet(styles)((props) => {

  const { products = [], showCommenting, showTrendingNow, showArticleSentiment, onSelect } = props

  useEffect(() => {
    if(showCommenting) onSelect('COMMENTING_V2')
    if(showTrendingNow) onSelect('TRENDING_NOW_V2')
    if(showArticleSentiment) onSelect('ARTICLE_SENTIMENT_V2')
  }, [showCommenting, showTrendingNow, showArticleSentiment])

  return (
  <Space klass={`producttabs ${props.classes.producttabs}`}>
    {products.filter(product => {
      if(product === 'COMMENTING_V2' && showCommenting) return product
      if(product === 'TRENDING_NOW_V2' && showTrendingNow) return product
      if(product === 'ARTICLE_SENTIMENT_V2' && showArticleSentiment) return product
    }).map(product => (
      <Space alignItems={'center'} justifyContent={'center'} klass={'icons'}>
        {product === 'COMMENTING_V2' && showCommenting && <CommentIcon width={18} height={18} onClick={() => onSelect(product)} />}
        {product === 'TRENDING_NOW_V2' && showTrendingNow && <TrendingNowIcon width={30} height={30} onClick={() => onSelect(product)} />}
        {product === 'ARTICLE_SENTIMENT_V2' && showArticleSentiment &&  <ArticleSentimentIcon width={18} height={18} onClick={() => onSelect(product)} />}
      </Space>
    ))}
  </Space>
   
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ProductTabs;
